import React from 'react'
import styled from 'styled-components'
import ServiceBG01 from '../../../../assets/bg/pc/bg_service_01.png'
import ServiceBG02 from '../../../../assets/bg/pc/bg_service_02.png'
import ServiceBG03 from '../../../../assets/bg/pc/bg_service_03.png'
import ServiceBG04 from '../../../../assets/bg/pc/bg_service_04.png'
import ServiceBG05 from '../../../../assets/bg/pc/bg_service_05.png'
import ServiceBG06 from '../../../../assets/bg/pc/bg_service_06.png'


const ServicePCComponent = () => {
  return (
    <StyledWrap>
      <img className={'service_01'} src={ServiceBG01} />
      <img className={'service_02'} src={ServiceBG02} />
      <img className={'service_03'} src={ServiceBG03} />
      <img className={'service_04'} src={ServiceBG04} />
      <img className={'service_05'} src={ServiceBG05} />
      <img className={'service_06'} src={ServiceBG06} />
    </StyledWrap>
  )
}

export default ServicePCComponent

const StyledWrap = styled.div`
  background: #f5f5f5;
  z-index: 10;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  /* 
  & > img {
    margin: 0 auto;
  } */

  .service_01 {
    padding-top: 219px;
    width: 67%;
  }

  .service_02 {
    width: 75%;
    padding-top: 294px;
    margin-left: 8%;
  }

  .service_03 {
    width: 75%;
    padding-top: 295px;
  }

  .service_04 {
    width: 67%;
    padding-top: 295px;
  }

  .service_05 {
    // width: 75%;
    padding-top: 295px;
  }

  .service_05 {
    // width: 75%;
    padding-top: 295px;
  }
`
